<template>

  <div>
    <b-row>
      <b-col>
        <SearchOpts v-if="esOdontologia" v-model="temp.procedimiento"
          :searchService="procedimientosServiceByEstablecimientoOdonto"
          :placeholder="'Buscar procedimiento por nombre o codigo'" :omit="omitProcedimientos" :minChars="3" />
        <SearchOpts v-else v-model="temp.procedimiento" :searchService="procedimientosServiceByEstablecimiento"
          :placeholder="'Buscar procedimiento por nombre o codigo'" :omit="omitProcedimientos" :minChars="3" />
      </b-col>
    </b-row>


    <b-row v-if="temp.procedimiento">
      <b-col md="6" class="mt-1" v-if="esIess">
        <span>Número de Orden AS400</span>
        <b-form-input v-model="temp.numeroOrden" id="v-norden" :state="errors.length > 0 ? false : null" type="number"
          @keypress="validateKeyPress('norden', $event)" />
      </b-col>

      <b-col md="12" class="mt-1">
        <span>Motivo de Solicitud</span>
        <b-form-textarea v-model="temp.motivoSolicitud" placeholder="Escriba el motivo de la solicitud..." rows="2"
          no-resize />
      </b-col>

      <b-col md="12" class="mt-1">
        <span>Resumen Clínico</span>
        <b-form-textarea v-model="temp.resumenClinico" placeholder="Escriba el resumen clínico..." rows="2" no-resize />
      </b-col>

      <b-col md="12" class="mt-1" v-if="procesoRepetido">
        <span>Justificacion</span>
        <b-form-textarea v-model="temp.justificacion" placeholder="Escriba el resumen clínico..." rows="2" no-resize />
      </b-col>

      <b-col md="12" class="my-2 d-flex justify-content-end">
        <b-button v-if="!indexToEdit" variant="info" size="sm" @click="onAddTable()">
          <span>Agregar</span>
          <i class="fas fa-solid fa-plus ml-1" title="Agregar Proceso" />
        </b-button>

        <b-button v-if="indexToEdit" variant="info" size="sm" @click="editarProceso" style="cursor: pointer;">
          Guardar
        </b-button>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import { SearchOpts } from '@/shared/components';
import { procedimientosService } from '@/views/procesoclinico/services';
import { getEstablecimientoLS } from '@/shared/helpers';
import { mapState } from 'vuex';


export default {

  props: {

    procesosList: {
      type: Array,
      default: () => []
    },

    esIess: {
      type: Boolean,
      default: false
    },

    indexToEdit: {
      type: String,
      default: null
    },
  },

  components: {
    SearchOpts
  },



  created() {
    if (this.indexToEdit) this.loadDataToEdit();
  },


  data() {
    return {
      // procesosList: [],

      temp: {
        procedimiento: null,
        procedimiento_odonto: null,
        procesoRepetido: false,
        numeroOrden: null,
        motivoSolicitud: null,
        resumenClinico: null,
        justificacion: null,
      },

      procesoRepetido: false,
      esOdontologia: false,

      errors: [],
    }
  },

  methods: {


    loadDataToEdit() {
      const procesoToEdit = { ...this.procesosList[this.indexToEdit] }
      this.temp = procesoToEdit;

      console.log('procesoToEdit', procesoToEdit)
    },


    async onAddTable() {

      if (!this.esIess) this.temp.numeroOrden = this.generateCodeDate();

      const isProcesoCompleto = this.isProcesoCompleto();
      if (!isProcesoCompleto) return;


      const hayOrdenRepetida = this.validarOrdenRepetida();
      if (hayOrdenRepetida) return;


      const hayProcesoRepetido = this.validateProcesoRepetido();
      if (hayProcesoRepetido) return;

      let newProceso = {
        action: 'crear',
        procedimiento: this.temp.procedimiento,
        procedimiento_odonto: null,
        numeroOrden: this.temp.numeroOrden,
        motivoSolicitud: this.temp.motivoSolicitud,
        resumenClinico: this.temp.resumenClinico,
        justificacion: this.temp.justificacion,
        odonto: this.esOdontologia,
      };

      if (this.esOdontologia) {
        newProceso.procedimiento_odonto = this.temp.procedimiento

      }


      this.procesosList.push(newProceso);
      this.limpiarFormulario()
    },

    procedimientosServiceByEstablecimiento(search) {
      const establecimiento = getEstablecimientoLS();
      return procedimientosService.searchByQuery(search, establecimiento.id)
    },

    procedimientosServiceByEstablecimientoOdonto(search) {
      const establecimiento = getEstablecimientoLS();
      return procedimientosService.searchByQueryOdonto(search, establecimiento.id)
    },



    limpiarFormulario() {

      this.temp = {
        procedimiento: null,
        procedimiento_odonto: null,
        procesoRepetido: false,
        numeroOrden: null,
        motivoSolicitud: null,
        resumenClinico: null,
        justificacion: null,
      }

    },


    generateCodeDate() {
      return new Date().getTime().toString();
    },


    validateKeyPress(campo, event) {
      if (campo === "numeroOrden" && this.numeroOrden.length >= 10 && !['Backspace', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
      }
    },

    isProcesoCompleto() {

      const validationA = this.temp.procedimiento
        && this.temp.numeroOrden?.trim()
        && this.temp.motivoSolicitud
        && this.temp.resumenClinico

      // const justificacionValida = (this.procesoRepetido && this.temp.justificacion.trim());

      const isCompleted = validationA

      if (!isCompleted) {
        this.$swal({
          title: 'Error',
          text: 'Por favor, complete todos los campos requeridos antes de agregar el proceso.',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }

      return isCompleted
    },

    validarOrdenRepetida() {
      const procesoRepetido = this.procesosList.find(proceso => proceso.numeroOrden === this.numeroOrden);

      if (procesoRepetido) {
        this.$swal({
          title: 'Orden Repetida',
          text: 'La orden ya se encuentra en la lista de procesos. Debera ingresar un numero de orden diferente.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
      }

      return !!procesoRepetido;
    },


    validateProcesoRepetido() {

      if (this.indexToEdit) return false;

      const procesoRepetido = this.procesosList.find(proceso => proceso.procedimiento.value === this.temp.procedimiento.value);
      this.procesoRepetido = !!procesoRepetido;

      if (this.procesoRepetido && !this.temp.justificacion) {
        this.$swal({
          title: 'Proceso Repetido',
          text: 'El proceso clínico ya se encuentra en la lista de procesos. Debera agregar una justificación.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
      }

      return procesoRepetido && !this.temp.justificacion
    },



    editarProceso() {


      const isProcesoCompleto = this.isProcesoCompleto();
      if (!isProcesoCompleto) return;

      const hayOrdenRepetida = this.validarOrdenRepetida();
      if (hayOrdenRepetida) return;

      const hayProcesoRepetido = this.validateProcesoRepetido();
      if (hayProcesoRepetido) return;

      const procesoEditado = {
        ...this.temp,
        action: this.temp.action !== 'crear' ? 'editar' : 'crear',
      }


      this.$set(this.procesosList, this.indexToEdit, procesoEditado);
      this.$emit('closeModal');
      this.limpiarFormulario();
    }

  },


  computed: {

    omitProcedimientos() {
      const omit = [];
      return omit;
    },

    ...mapState({
      codEsp: state => state.atencionCita.dataCita?.doctor.especialidad.codEsp,
      stEspecialidad: state => state.atencionCita.dataCita?.doctor.especialidad,
      stSemFisiatrica: state => state.atencionCita.semiologias?.semFisiatrica,
      stMotivoConsulta: state => state.atencionCita.anamnesis?.motivoConsulta?.tipoVez,
      stDataDoctor: state => state.atencionCita.dataCita?.doctor,
    }),



  },


  watch: {

    'temp.procedimiento': {
      handler(newValue) {
        if (newValue) this.validateProcesoRepetido();
        if (!newValue && !this.indexToEdit) this.limpiarFormulario();
      }
    },

    stEspecialidad: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          if (newValue.codEsp && newValue.codEsp === '0000000134') {

            this.esOdontologia = true
          } else {
            this.esOdontologia = false
          }
        }
      }
    },


    temp: {
      deep: true,
      handler(newValue) {
        // console.log(newValue)
      }
    },
  }
}
</script>
